<template>
  <section class="login-content">
    <div class="main">
      <form class="first" @submit="submit" @input="clearWarning">
        <h3>{{login_}}</h3>
        <div class="username">
          {{username_}}<br/>
          <input type="text" v-model="username" @keypress.enter="submit" />
        </div>
        <div class="password">
          {{password_}}<br/>
          <input type="password" v-model="password" @keypress.enter="submit"/>
        </div>
        <div class="buttons">
          <div class="error">{{msg}}</div>
          <a class="btn btn-large" @click="submit" style="margin-right: 30px">{{submit_}}</a>
          <a class="btn btn-large" @click="toRegister">{{register_}}</a>
        </div>
      </form>
      <router-link class="register_link" to="/forgetPwd">{{forgetPwd_}}</router-link>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { hash } from '@/utils'
  import { login } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        username: '',
        password: '',
        msg: '',
        showForgotten: false
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale']),
      ...mapGetters(['gameOver']),
      ...i18n.map([
        'login_', 'username_', 'password_',
        'submit_', 'register_', 'forgetPwd_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      clearWarning () {
        this.msg = ''
      },
      submit () {
        const uid = this.username
        if (!uid) {
          this.msg = this.i18n.invalidUsername
          return
        }

        login(uid, hash(uid, this.password))
          .then((data) => {
            this.profile.name = uid
            this.$router.push('/profile')
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      forgot_password () {
        this.showForgotten = !this.showForgotten
      },
      toRegister () {
        this.$router.push('/register')
      }
    },
    created () {
      // 由于有上传 writeup 功能，比赛结束之后，还需要选手登录上传 writeup，因此不能禁止比赛之后选手登录
      // if (this.gameOver) return this.$router.replace('/rank')
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/login.vue